import { isEmpty } from 'lodash';

import { ENGINE_DATA } from 'commons-vehicle/constants/dataConversions.js';
import EngineModel from 'commons-vehicle/ModelYear/models/EngineModel.js';
/* eslint import/prefer-default-export: 0 */

export function resetEngineFromConfigurationData(configurationEngineData) {
    if (isEmpty(configurationEngineData) || configurationEngineData.length <= ENGINE_DATA.TORQUE_RPM) {
        return new EngineModel();
    }

    const selectionCode =
        `${configurationEngineData[ENGINE_DATA.DISPLACEMENT]}L-` +
        `${configurationEngineData[ENGINE_DATA.CYLINDERS]}C-` +
        `${configurationEngineData[ENGINE_DATA.IS_TURBO] ? 'T-' : ''}` +
        `${configurationEngineData[ENGINE_DATA.FUEL]}`;

    return new EngineModel({
        selectionCode,
        code: '',
        fuelTypeCode: configurationEngineData[ENGINE_DATA.FUEL],
        cylinders: configurationEngineData[ENGINE_DATA.CYLINDERS],
        displacement: configurationEngineData[ENGINE_DATA.DISPLACEMENT],
        isTurbo: configurationEngineData[ENGINE_DATA.IS_TURBO],
        hp: configurationEngineData[ENGINE_DATA.HP],
        hpRpm: configurationEngineData[ENGINE_DATA.HP_RPM],
        torque: configurationEngineData[ENGINE_DATA.TORQUE],
        torqueRpm: configurationEngineData[ENGINE_DATA.TORQUE_RPM],
    });
}

export default {
    resetEngineFromConfigurationData,
};



// WEBPACK FOOTER //
// ./src/ModelYear/services/EngineService/EngineService.js